module.exports = __webpack_public_path__ + "static/media/2.bd47bce8.png";